import React from "react";
import clsx from "clsx";

import Button from "@material-ui/core/Button";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import {
  EVariantExamsHistory,
  getVariantsClassNames
} from "../VetExams/ExamHistoryItem/helper";
import { useLoggedInUser } from "../LoggedInUserProvider";
import useStyles from "./styles";

interface IProps {
  status: racehorse360.HealthWatchStatus;
  variant?: EVariantExamsHistory;
  onClick?: () => void;
}

const RiskLevel = (props: IProps) => {
  const { status, onClick, variant } = props;
  const classes = useStyles();
  const { currentUser } = useLoggedInUser();

  const { detailsClassName } = getVariantsClassNames(variant);
  let rating, className;

  if (!status) return <span>&#8211;</span>;

  switch (status) {
    case racehorse360.HealthWatchStatus.HEALTH_WATCH_STATUS_GREEN:
      rating = "LOW";
      className = "low";
      break;
    case racehorse360.HealthWatchStatus.HEALTH_WATCH_STATUS_YELLOW:
      rating = "MEDIUM";
      className = "medium";
      break;
    case racehorse360.HealthWatchStatus.HEALTH_WATCH_STATUS_RED:
      rating = "HIGH";
      className = "high";
  }

  const isClickable = onClick && !currentUser.isRegulatoryVet;

  return isClickable ? (
    <Button
      onClick={onClick}
      className={clsx(
        classes.root,
        classes.button,
        detailsClassName,
        classes[className]
      )}
    >
      {rating}
    </Button>
  ) : (
    <span className={clsx(classes.root, detailsClassName, classes[className])}>
      {rating}
    </span>
  );
};

export default RiskLevel;
